'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SearchProbeList;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _utilsImmutable = require('@bibliocommons/utils-immutable');

var _searchProbe = require('../../search-probe');

var _searchProbe2 = _interopRequireDefault(_searchProbe);

require('../styles/SearchProbeList.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SearchProbeList(_ref) {
  var probes = _ref.probes;

  if (!probes || (0, _utilsImmutable.isEmpty)(probes)) {
    return null;
  }

  return _react2.default.createElement(
    'div',
    { className: 'cp-search-probe-list' },
    _react2.default.createElement(
      'h2',
      null,
      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'searchProbeAlsoAt' })
    ),
    _react2.default.createElement(
      'ul',
      { className: 'probe-list' },
      probes.map(function (probe) {
        return _react2.default.createElement(
          'li',
          { key: probe.siteId },
          _react2.default.createElement(_searchProbe2.default, probe)
        );
      })
    )
  );
}

SearchProbeList.propTypes = {
  probes: _react.PropTypes.arrayOf(_react.PropTypes.shape({
    siteId: _react.PropTypes.string.isRequired,
    libraryName: _react.PropTypes.string.isRequired,
    count: _react.PropTypes.number,
    searchUrl: _react.PropTypes.string.isRequired
  }))
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/probes/lib/components/search-probe-list/components/SearchProbeList.component.js
// module id = 1454
// module chunks = 1